import type { ScenarioEntry } from './types';
/** Source categories only, in first-appearance order. */
export function sourceCategories(entries: readonly ScenarioEntry[]): readonly string[] {
  return [...new Set(entries.map((e) => e.category))];
}
export function selectEntries(
  entries: readonly ScenarioEntry[],
  query: string,
  category: string,
): readonly ScenarioEntry[] {
  const needle = query.trim().toLocaleLowerCase();
  return entries.filter(
    (e) =>
      (!category || e.category === category) &&
      (!needle ||
        (e.code + ' ' + e.name + ' ' + e.category + ' ' + JSON.stringify(e.source))
          .toLocaleLowerCase()
          .includes(needle)),
  );
}
